import { FaPhone, FaSms, FaWhatsapp } from 'react-icons/fa';
import contactConfig from '../config/contact';
import { useLanguage } from '../contexts/LanguageContext';

const ContactActions = ({ compact = false }) => {
  const { language } = useLanguage();
  const es = language === 'es';
  return (
  <section aria-label={es ? 'Contacto rápido' : 'Quick contact'} className={`${compact ? 'py-8' : 'py-10'} px-4 bg-black text-white m-0`}>
    <div className="max-w-5xl mx-auto text-center">
      {!compact && <p className="text-lg font-bold mb-5">{es ? '¿Listo para hablar de tu letrero? Llámanos, envía un texto o escríbenos por WhatsApp.' : 'Ready to talk about your sign? Call, text or send us a WhatsApp message.'}</p>}
      <div className="grid sm:grid-cols-3 gap-3">
        <a href={contactConfig.phone.tel} className="flex items-center justify-center gap-3 rounded-xl bg-white px-5 py-4 text-black font-black"><FaPhone /> {es ? 'Llamar' : 'Call'}</a>
        <a href={`sms:+${contactConfig.phone.clean}`} className="flex items-center justify-center gap-3 rounded-xl border-2 border-atlantis px-5 py-4 text-white font-black"><FaSms /> {es ? 'Texto' : 'Text'}</a>
        <a href={`${contactConfig.phone.whatsapp}?text=${encodeURIComponent(contactConfig.social.whatsappMessage)}`} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-3 rounded-xl bg-[#25D366] px-5 py-4 text-black font-black"><FaWhatsapp /> WhatsApp</a>
      </div>
      <p className="mt-4 text-sm text-gray-300">{contactConfig.phone.display} · Houston & Katy</p>
    </div>
  </section>
  );
};

export default ContactActions;
